import { useEffect, useState } from 'react';

let lookupPromise;
function loadLookup() {
    if (!lookupPromise) lookupPromise = Promise.all([
        import('./nearestProvince.js'), import('./data/indonesia-provinces.json'),
    ]).then(([{ createProvinceLookup }, { default: data }]) => {
        if (data.features?.length !== 38) throw new Error('Incomplete province boundaries');
        return createProvinceLookup(data.features);
    }).catch(error => { lookupPromise = undefined; throw error; });
    return lookupPromise;
}

export default function useNearestProvinces(reports) {
    const key = JSON.stringify([...new Set(reports.map(row => JSON.stringify([row.lat, row.lng])))].sort());
    const [state, setState] = useState({ key: '', values: {}, error: false });
    useEffect(() => {
        let cancelled = false;
        const coordinates = JSON.parse(key);
        if (!coordinates.length) return;
        (async () => {
            try {
                const lookup = await loadLookup();
                const values = {};
                for (const coordinate of coordinates) {
                    if (cancelled) return;
                    values[coordinate] = lookup(...JSON.parse(coordinate));
                    // Yield between vessels so table controls stay responsive.
                    await new Promise(resolve => setTimeout(resolve, 0));
                }
                if (!cancelled) setState({ key, values, error: false });
            } catch {
                if (!cancelled) setState({ key, values: {}, error: true });
            }
        })();
        return () => { cancelled = true; };
    }, [key]);
    return state.key === key ? { ...state, loading: false } : { values: {}, error: false, loading: reports.length > 0 };
}
